<template>
  <div>
    <div v-if="items" class="columns is-multiline">
        <div :key="item.id" v-for="item in items" class="column is-one-third">
            <div class="card">
                <div class="card-content">
                    <p class="title is-4">{{item.name}}</p>
                    <p class="subtitle is-6">{{item.url}}</p>
                </div>
                <footer class="card-footer">
                    <router-link class="card-footer-item" :to="`pages/${item.id}`">View</router-link>
                </footer>
            </div>
        </div>
    </div>
    <loading v-if="isLoading"></loading>
  </div>
</template>

<script>
import loading from "@/components/Loading";
import { GET_PAGES } from "@/store/actions"

export default {
  name: "Pages",
  components: { loading },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
      items(){
          return this.$store.state.pages.data;
      }
  },
  mounted(){
      if(!this.items){
          this.getPages();
      }
  },
  methods:{
      getPages(){
          this.isLoading = true;
          this.$store.dispatch(GET_PAGES).finally(() => {
              this.isLoading = false;
          });
      }
  }
};
</script>

